import { render, staticRenderFns } from "./addDocuments.vue?vue&type=template&id=b1ee32d2&"
import script from "./addDocuments.vue?vue&type=script&lang=js&"
export * from "./addDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports